/* Section FAQ : navigation par rubriques (onglets verticaux).
   Amélioration progressive : sans JS, toutes les rubriques restent affichées
   les unes sous les autres, chacune avec son titre. Le JS ajoute la classe
   bnz-faq--enhanced, qui active la colonne de gauche et masque les panneaux
   non sélectionnés. */

(function () {
  var DESKTOP = '(min-width: 990px)';

  function BnzFaq(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('.bnz-faq__topic'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('.bnz-faq__panel'));
    if (!this.tabs.length || !this.panels.length) return;

    this.mql = window.matchMedia(DESKTOP);
    this.current = null;

    root.classList.add('bnz-faq--enhanced');
    this.bind();
    this.restore();
    root.bnzFaq = this;
  }

  BnzFaq.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab, index) {
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      tab.addEventListener('click', function () {
        self.select(tab.getAttribute('aria-controls'), true);
      });
      tab.addEventListener('keydown', function (event) {
        self.onKeydown(event, index);
      });
    });

    this.root.querySelectorAll('.bnz-faq__back').forEach(function (button) {
      button.addEventListener('click', function () {
        self.closePanel();
      });
    });

    this.onHashChange = function () {
      self.revealHash(window.location.hash, false);
    };
    window.addEventListener('hashchange', this.onHashChange);

    // Un lien interne peut viser une ancre rangée dans un autre panneau
    // (ex. le tableau des frais appelé depuis une réponse).
    this.onDocumentClick = function (event) {
      var link = event.target.closest && event.target.closest('a[href*="#"]');
      if (!link) return;
      var hash = link.hash;
      if (!hash || hash.length < 2) return;
      if (link.pathname && link.pathname !== window.location.pathname) return;
      if (self.revealHash(hash, true)) event.preventDefault();
    };
    document.addEventListener('click', this.onDocumentClick);

    this.onResize = function () {
      if (self.mql.matches && !self.current) self.select(self.panels[0].id, false);
      self.syncMobileState();
    };
    if (this.mql.addEventListener) {
      this.mql.addEventListener('change', this.onResize);
    } else if (this.mql.addListener) {
      this.mql.addListener(this.onResize);
    }
  };

  BnzFaq.prototype.restore = function () {
    if (this.revealHash(window.location.hash, false)) return;
    if (this.mql.matches) {
      this.select(this.panels[0].id, false);
    } else {
      this.select(null, false);
    }
  };

  BnzFaq.prototype.select = function (panelId, fromClick) {
    var self = this;

    this.panels.forEach(function (panel) {
      panel.hidden = panelId ? panel.id !== panelId : true;
    });

    this.tabs.forEach(function (tab) {
      var selected = tab.getAttribute('aria-controls') === panelId;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      if (selected && fromClick) tab.focus();
    });

    this.current = panelId;
    this.syncMobileState();

    if (fromClick && !this.mql.matches) {
      var panel = panelId && document.getElementById(panelId);
      if (panel) {
        var back = panel.querySelector('.bnz-faq__back');
        if (back) back.focus();
        self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  BnzFaq.prototype.closePanel = function () {
    var previous = this.current;
    this.select(null, false);
    this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var tab = previous && this.root.querySelector('[aria-controls="' + previous + '"]');
    if (tab) tab.focus();
  };

  BnzFaq.prototype.syncMobileState = function () {
    this.root.classList.toggle('is-panel-open', Boolean(this.current));
    if (this.mql.matches && !this.current) this.select(this.panels[0].id, false);
  };

  // Ouvre le panneau (et le cas échéant l'accordéon) qui contient l'ancre visée.
  BnzFaq.prototype.revealHash = function (hash, scroll) {
    if (!hash || hash.length < 2) return false;
    var target;
    try {
      target = this.root.querySelector(hash);
    } catch (error) {
      return false;
    }
    if (!target) return false;

    var panel = target.closest('.bnz-faq__panel');
    if (!panel) return false;

    this.select(panel.id, false);

    var item = target.closest('.bnz-faq__item') || (target.matches('.bnz-faq__item') ? target : null);
    if (item) item.open = true;

    if (scroll) {
      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      if (window.history.replaceState) window.history.replaceState(null, '', hash);
    }
    return true;
  };

  function init(scope) {
    (scope || document).querySelectorAll('.bnz-faq--topics').forEach(function (root) {
      if (!root.bnzFaq) new BnzFaq(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
